export default function changePasswordTemporary(to, from, next) {
    if (to.meta.resetPasswordTemporary) {
        const resetPassword = localStorage.getItem('change_password');
        if (resetPassword == 'true') {
            next('/change-password-temporary');
        }
    }

    next();
}